import React from "react";
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";

// Material-UI
import { Button, Container, Grid, makeStyles } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import TextPilih from "../components/TextPilih";
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  bgWhite: {
    backgroundColor: "white"
  }
}));

const PilihMateri = ( {classes} ) => {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    if (data.pilihMateri !== "Diklat-1") {
      return Swal.fire({
        icon: "error",
        title: "Diklat Belum Dimulai",
        text: "Silahkan Pilih Diklat yang sedang dilaksanakan",
      });
    } else {
      return history.push('/user/materi-diklat/1')
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={6} sm={6} md={5}>
            <FormControl className={classes.bgWhite} variant="outlined" margin="normal" required fullWidth>
              <InputLabel id="pilihMateriLabel">{"Pilih Materi"}</InputLabel>
              <Controller
                as={
                  <Select
                    labelId="pilihMateriLabel"
                    id="pilihMateri"
                    label="Pilih Materi"
                  >
                    <MenuItem value="">
                      <em>Pilih Materi Diklat</em>
                    </MenuItem>
                    <MenuItem value="Diklat-1">{"Diklat-1"}</MenuItem>
                    <MenuItem value="Diklat-2">{"Diklat-2"}</MenuItem>
                    <MenuItem value="Diklat-3">{"Diklat-3"}</MenuItem>
                    <MenuItem value="Diklat-4">{"Diklat-4"}</MenuItem>
                  </Select>
                }
                name="pilihMateri"
                control={control}
                defaultValue=""
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={5} sm={4} md={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
            >
              {"Pilih"}
            </Button>
          </Grid>
          <Grid item xs={1} sm={2} md={4}></Grid>
        </Grid>
      </form>
    </Container>
  );
};

const UserMateriDiklat = () => {
  const classes = useStyles();

  return (
    <section id="materi-diklat" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Materi Pendidikan dan Pelatihan (DIKLAT)" />
        <TextPilih text="Pilih Materi Diklat yang ingin diunduh"/>
        <PilihMateri classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserMateriDiklat;
